import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';
import { singularize } from '@blaze-shared/shared-util';

import { PropsBuilder } from '../__base/props-builder';

export class FormContainerPropsBuilder extends PropsBuilder<'formContainer'> {
  override setLabel = (label: string, enable?: boolean): this => {
    this.labelFnsSetLabel(singularize(label), enable);
    return this;
  };

  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { container: { visualEffect } } });
    return this;
  };

  constructor(props: PartialPropsOf<'formContainer'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
